import { DOCUMENT, inject, Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

declare var grecaptcha: any;

export interface CaptchaParams {
  callback?: (token: string) => void;
  errorCallback?: () => {};
}

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  private readonly document = inject(DOCUMENT);
  private readonly loadedSource = new ReplaySubject<boolean>();
  private loaded = false;

  constructor() {
    this.loadScript();
  }

  private loadScript() {
    if (this.loaded) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=explicit`;
    script.defer = true;
    script.async = true;
    script.onload = () => {
      grecaptcha.ready(() => {
        this.loadedSource.next(true);
        this.loaded = true;
      });
    };
    this.document.head.appendChild(script);
  }

  render(element: HTMLElement) {
    const renderSource = new Subject<string>();

    return this.loadedSource.pipe(
      switchMap(() => {
        grecaptcha.render(element, {
          sitekey: environment.key_captcha,
          callback: (token: string) => {
            renderSource.next(token);
            renderSource.complete();
          },
          'error-callback': () => renderSource.error(new Error('Recaptcha error!')),
          'expired-callback': () =>
            renderSource.error(new Error('Recaptcha expired error!')),
        });

        return renderSource;
      }),
    );
  }
}
